import * as React from "react";
import { outlookEvent } from "../../Entity/OutlookEvent";
import "./event.scss";
export interface IProps {
  data: outlookEvent;
  phrases: any;
  GetEventAttachment;
}

export default class EventAttachmentlist extends React.Component<IProps> {
  public state ={loading:false,showattachments:false,attachmentlist:[]};
  
  constructor(props) {
    super(props);
    
  }
  public render() {
    
    return (
        <div className="Event">
            <i className="ms-Icon ms-Icon--Attach attachmenticon" />
            <span className='attchmentaction' onClick={this.showorhideattachment}>
                {this.state.showattachments?this.props.phrases.hideattachments:this.props.phrases.showattachments}
            </span>
            <div>
                {this.state.loading?(
                    <div className="mipaloading">&nbsp;</div>
                ):(this.PrepareAttachmentlist())}
            </div>
        </div>
        
    );
  }
  private showorhideattachment=()=>{
      var fnsuccess=(result)=>{
        this.setState({loading:false,attachmentlist:result.data.value});
      };
      if(this.state.showattachments){
          this.setState({showattachments:false});
      } else{
          if(this.state.attachmentlist.length==0){
              this.setState({showattachments:true,loading:true});
              let api=`v1.0/me/events/${this.props.data.id}/attachments?$select=id,name`;
              this.props.GetEventAttachment(api,fnsuccess);
          } else{
            this.setState({showattachments:true});
          }
      }
  }
  private PrepareAttachmentlist=()=>{
        let list=[];
        let hashCode = s => s.split('').reduce((a,b) => (((a << 5) - a) + b.charCodeAt(0))|0, 0)
        this.state.attachmentlist.forEach((val,index)=>{
            let key=`EventAttachment_${hashCode(this.props.data.id)}_${hashCode(val.id)}_${index}}`;
            // let url=`https://outlook.office.com/calendar/deeplink?viewmodel=IAttachmentViewModelPopoutFactory&AttachmentId=${encodeURIComponent(val.id)}&ItemId=${encodeURIComponent(this.props.data.id)}&AttachmentName=${encodeURIComponent(val.name)}`;
            let url=`https://outlook.office.com/mail/deeplink/attachment/${this.GetURLCompatibleID(this.props.data.id)}/${this.GetURLCompatibleID(val.id)}/false`;
            list.push(
            <div key={key} title={val.name} className="attachmentitem"><a href={url} className='texteclips' target='_blank'>{val.name}</a></div>
            );
        });
        return list;
  }
  private GetURLCompatibleID=(mailID)=> {
    if (mailID) {
        var find = '-';
        var re = new RegExp(find, 'g');
        mailID = mailID.replace(re, '/');
        find='_';
        mailID = mailID.replace(re, '+');
        
        return encodeURIComponent(mailID) ;
    } else {
        return mailID;
    }
  }
}
